var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-card",
    { attrs: { bordered: false } },
    [
      _c(
        "div",
        {
          staticClass: "table-operator",
          staticStyle: { "margin-bottom": "12px" },
        },
        [
          _c("h-select", {
            staticStyle: { width: "170px" },
            attrs: { placeholder: "查看范围", options: _vm.scopeOptions },
            on: { change: _vm.loadList },
            model: {
              value: _vm.scope,
              callback: function ($$v) {
                _vm.scope = $$v
              },
              expression: "scope",
            },
          }),
          _c(
            "a-button",
            {
              staticStyle: { "margin-left": "8px" },
              attrs: { type: "primary", icon: "plus" },
              on: {
                click: function ($event) {
                  return _vm.openEdit({})
                },
              },
            },
            [_vm._v("新增")]
          ),
          _c(
            "a-button",
            {
              staticStyle: { "margin-left": "8px" },
              attrs: { icon: "copy" },
              on: { click: _vm.copyFromSystem },
            },
            [_vm._v("从系统预置复制（如空）")]
          ),
          _c(
            "a-button",
            {
              staticStyle: { "margin-left": "8px" },
              attrs: { icon: "rollback" },
              on: { click: _vm.restorePreset },
            },
            [_vm._v("恢复系统预置")]
          ),
          _c(
            "a-button",
            {
              staticStyle: { "margin-left": "8px" },
              attrs: { icon: "sync" },
              on: { click: _vm.loadList },
            },
            [_vm._v("刷新")]
          ),
          _c(
            "p",
            {
              staticClass: "muted small",
              staticStyle: { "margin-top": "6px" },
            },
            [
              _vm._v(
                "\n      说明：系统预置行(tenant_id=0)仅超级管理员可编辑；租户管理员编辑的是「租户副本」。\n      对副本执行"
              ),
              _c("b", [_vm._v("删除=软删")]),
              _vm._v("，等效于"),
              _c("b", [_vm._v("禁用该系统预置项")]),
              _vm._v("，可点击「恢复系统预置」一键还原（Z模式）。\n    "),
            ]
          ),
        ],
        1
      ),
      _c("a-table", {
        attrs: {
          bordered: "",
          size: "middle",
          rowKey: "id",
          columns: _vm.cols,
          dataSource: _vm.rows,
          pagination: false,
          loading: _vm.loading,
        },
        scopedSlots: _vm._u([
          {
            key: "src_slot",
            fn: function (t) {
              return [
                _c(
                  "a-tag",
                  { attrs: { color: t === "system" ? "purple" : "green" } },
                  [_vm._v(_vm._s(t === "system" ? "系统预置" : "租户自定义"))]
                ),
              ]
            },
          },
          {
            key: "cat_slot",
            fn: function (t) {
              return [_c("a-tag", [_vm._v(_vm._s(t || "—"))])]
            },
          },
          {
            key: "en_slot",
            fn: function (t, r) {
              return [
                r.deleted
                  ? _c("span", { staticClass: "text-red" }, [
                      _vm._v("[已删除]"),
                    ])
                  : [
                      _c(
                        "a-tag",
                        {
                          attrs: {
                            color:
                              t === "1" || t === true ? "green" : "default",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(t === "1" || t === true ? "启用" : "停用")
                          ),
                        ]
                      ),
                    ],
              ]
            },
          },
          {
            key: "action",
            fn: function (t, r) {
              return [
                r._editable
                  ? [
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.openEdit(r)
                            },
                          },
                        },
                        [_vm._v("编辑")]
                      ),
                      _c("a-divider", { attrs: { type: "vertical" } }),
                      _c(
                        "a",
                        {
                          staticStyle: { color: "red" },
                          on: {
                            click: function ($event) {
                              return _vm.del(r)
                            },
                          },
                        },
                        [_vm._v("删除")]
                      ),
                    ]
                  : _c("span", { staticClass: "muted" }, [
                      _vm._v("系统行（无权限）"),
                    ]),
              ]
            },
          },
        ]),
      }),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.form.id
              ? "编辑主数据注册"
              : "新增主数据注册（辅助核算类别来源）",
            visible: _vm.modal,
            confirmLoading: _vm.saving,
            maskClosable: false,
            width: 680,
          },
          on: {
            ok: _vm.save,
            cancel: function ($event) {
              _vm.modal = false
            },
          },
        },
        [
          _c(
            "a-form",
            { attrs: { layout: "vertical" } },
            [
              _c(
                "a-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "辅助核算类别", required: "" } },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                "例：资金账户/客户/供应商/部门/职员/仓库/存货",
                            },
                            model: {
                              value: _vm.form.category_name,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "category_name", $$v)
                              },
                              expression: "form.category_name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "类别类型", required: "" } },
                        [
                          _c(
                            "a-select",
                            {
                              model: {
                                value: _vm.form.category_type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "category_type", $$v)
                                },
                                expression: "form.category_type",
                              },
                            },
                            [
                              _c(
                                "a-select-option",
                                { attrs: { value: "system" } },
                                [_vm._v("系统型（引用主数据表）")]
                              ),
                              _c(
                                "a-select-option",
                                { attrs: { value: "custom" } },
                                [_vm._v("自定义型（独立明细表）")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.form.category_type === "system"
                    ? _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c("a-alert", {
                            attrs: {
                              type: "info",
                              showIcon: "",
                              message:
                                "系统型：辅助明细直接引用业务主数据表，保证数据单一来源；系统预置的9项不建议修改。",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.category_type === "system"
                    ? _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "主数据表名(source_table)" } },
                            [
                              _c(
                                "a-select",
                                {
                                  attrs: { showSearch: "" },
                                  model: {
                                    value: _vm.form.source_table,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "source_table", $$v)
                                    },
                                    expression: "form.source_table",
                                  },
                                },
                                _vm._l(_vm.sourceTables, function (t) {
                                  return _c(
                                    "a-select-option",
                                    { key: t.v, attrs: { value: t.v } },
                                    [
                                      _vm._v(
                                        _vm._s(t.v) + " · " + _vm._s(t.label)
                                      ),
                                    ]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.category_type === "system"
                    ? _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "名称列(source_name_column)" } },
                            [
                              _c("a-input", {
                                attrs: {
                                  placeholder: "例：name / supplier / org_abr",
                                },
                                model: {
                                  value: _vm.form.source_name_column,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "source_name_column",
                                      $$v
                                    )
                                  },
                                  expression: "form.source_name_column",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.category_type === "system"
                    ? _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "编码列(source_code_column)" } },
                            [
                              _c("a-input", {
                                attrs: {
                                  placeholder:
                                    "例：code / model / org_no / 可空",
                                },
                                model: {
                                  value: _vm.form.source_code_column,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "source_code_column",
                                      $$v
                                    )
                                  },
                                  expression: "form.source_code_column",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.category_type === "system"
                    ? _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "过滤启用状态值(enabled_filter_value)",
                              },
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  placeholder: "默认 1；有些表用 bit(1) 则写 1",
                                },
                                model: {
                                  value: _vm.form.enabled_filter_value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "enabled_filter_value",
                                      $$v
                                    )
                                  },
                                  expression: "form.enabled_filter_value",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "启用状态" } },
                        [
                          _c("a-switch", {
                            attrs: {
                              "checked-children": "开",
                              "un-checked-children": "关",
                            },
                            model: {
                              value: _vm.form.is_enabled,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "is_enabled", $$v)
                              },
                              expression: "form.is_enabled",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "排序号(sort)" } },
                        [
                          _c("a-input-number", {
                            attrs: { min: 0, precision: 0 },
                            model: {
                              value: _vm.form.sort,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "sort", $$v)
                              },
                              expression: "form.sort",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }